<div id="container">
  <div id="left"></div>
  <div id="right">
    <span class="verbiage"
    >மழைநீர் சேமிப்போம் &nbsp;&nbsp; மழைநீர் உயிர்நீர்
  </span>
  <span class="verbiage"
    >எனது குப்பை எனது பொறுப்பு 
  </span>

    <div >
      <h3 id="login">
        <img
        alt="Tamilnadu logo"
          src="./assets/images/tnmunipal-logo.png"
        /><br />
      </h3>
      <form #loginForm="ngForm" (ngSubmit)="onSubmit(loginForm)">
        <input
          title="username"
          type="text"
          id="username"
          class="client-info mt-4"
          autocomplete="off"
          name="userName"
          required
          ngModel
          #userName="ngModel"
        />

        <label for="text">User Name *</label>

        <input
          type="password"
          name="password"
          id="password"
          class="client-info"
          ngModel
          required
          #password="ngModel"
        />
        <label for="password">Password *</label>
        <!-- <div class=" form-switch">
          
          <div class="form-check-label " for="flexSwitchCheckDefault">
            
            If you are working more than one ULB&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <input class="form-check-input " (click)="multiOrg()" type="checkbox" role="switch" id="flexSwitchCheckDefault">
          </div>
        </div> -->
        <select *ngIf="ddshow === true"
              class="form-select form-select-sm"
            >
                <option value="0">Agencies</option>
                <option value="1">EAP</option>
              </select>&nbsp;
        <span
        
          class="error"
          *ngIf="
            (!userName?.valid && (userName?.dirty || userName?.touched)) ||
            (!password?.valid && (password?.dirty || password?.touched))
          "
        >
          User Name & Password is Mandatory(*)
        </span>
        <span class="error"> {{error}}</span>
        <input
          [disabled]="!loginForm.valid"
          type="submit"
          id="submit"
          class="client-info"
          value="Submit"
        />
      </form>
    </div>
  </div>
</div>
